export enum TaskReviewStatus {
  NoRisks,
  Open,
  InReview,
  Resolved,
  Reviewed,
}
